import StylingTextStaticToRTEProps from 'styling/hocs/StylingToRTEProps/StylingTextStaticToRTEProps';

import QuestionRichText from './QuestionRichText';

export default StylingTextStaticToRTEProps(QuestionRichText);
